import { useState } from 'react';
import { useSelector } from 'react-redux';

import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import userContext from 'features/views/userContext';

import Filter from './components/Filter';
import SubordinateUsersTable from './components/Table';
import Toolbar from './components/Toolbar';

export const SubordinateUsers = () => {
	const contextUser = useSelector(userContext.selectors.getContextUser);
	const [resettingSubordinateUsersOnly, setResettingSubordinateUsersOnly] = useState(false);

	return (
		<Panel screenId={PAGES.subordinateUsers.id} screenName={PAGES.subordinateUsers.name}>
			<PaperWithToolbar
				toggledElement={
					<Filter
						resettingSubordinateUsersOnly={resettingSubordinateUsersOnly}
						setResettingSubordinateUsersOnly={setResettingSubordinateUsersOnly}
					/>
				}
				toolbar={<Toolbar setResettingSubordinateUsersOnly={setResettingSubordinateUsersOnly} />}
				collapsibleProps={{ id: subheaders.subordinateUsers, initiallyOpen: true }}
			>
				<SubordinateUsersTable contextUser={contextUser} />
			</PaperWithToolbar>
		</Panel>
	);
};

export default SubordinateUsers;
